<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/euVYoj/tc-custom/9781613123669.jpg?1703706241041" alt="This image is the cover for the book P.S. I Still Hate It Here"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">P.S. I Still Hate It Here
      </h1>
      <p class="bookDescription body article font2">
        <b>Another collection of hilarious real-life letters from kids at summer camp sure to amuse anyone who’s ever been a homesick child or a parent of one.</b><br/><br/>From the editor of the bestselling <i>P.S. I Hate It Here </i>comes an all-new, even more outrageous and laugh-out-loud funny collection of real letters written by children ages eight to sixteen to their parents about their adventures at summer camp. Written with the same wit and honesty as those in the first book, these new letters take the reader on a familiar adventure that conjures up the experience of being away from home, and the hilarious and lasting memories that accompany that special place called sleepaway camp.<br/><br/><b>Praise for <i>P.S. I Still Hate It Here</i></b><br/><br/><b>“Will give you and your friends a good laugh while you’re at the beach and the kids are away.” —<i>Geek Mom</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Falanga
      </h2>
      
      <p class="authorDescription body article">Diane Falanga, author of P.S. I Hate it Here: Kids’ Letters from Camp, is a mother of two and was inspired to put these books together after receiving melodramatic camp letters home from her then eight-year-old daughter. Diane lives on Chicago’s North Shore.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams Image
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?841784aa